<div class="view-container">
  <mat-card>
    <mat-card-content>

      <!-- Upload section -->
      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content>
          <div class="file-drop-zone" [class.disabled]="!uploadCategory"
               (drop)="dropHandler($event)" (dragover)="$event.preventDefault();"
               fxLayoutAlign="center center">
            <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
              
              <mat-icon>upload</mat-icon>

              <ng-container *ngIf="uploadCategory">
                <span>Drag and drop files here to upload</span>
                <small>or</small>
                <button mat-stroked-button (click)="onAddNewFileClick()">
                  Select Files
                  <input class="upload-input" id="upload-file-input" type="file"
                         (change)="onFileChosen($event)" onclick="value = null" accept="*" multiple/>
                </button>
              </ng-container>

              <span *ngIf="!uploadCategory">Select an upload category to begin</span>

              <div class="m-t-10" fxLayout="column" fxLayoutAlign="center center">
                <mat-form-field class="upload-category-field">
                  <mat-label>Upload Category</mat-label>
                  <mat-select [(value)]="uploadCategory" (selectionChange)="onUploadCategoryChanged()">
                    <mat-option *ngFor="let cat of authorizedCategories" [value]="cat">{{ getCategoryLabel(cat) }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <ng-container *ngIf="uploadCategory">
                  <div *ngIf="validFileExtensions.length > 0" class="valid-file-types" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                    <small style="white-space: nowrap;">Valid File Types:</small>
                    <small>{{ buildValidFileTypesString() }}</small>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Pending files list -->
          <div *ngIf="newFiles.length > 0" class="pending-files">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="pending-files-header">
              <strong>Pending Files ({{ newFiles.length }})</strong>
              <button mat-flat-button color="primary"
                      [disabled]="uploading"
                      [class.button-spinner]="uploading"
                      (click)="uploadAllNewFiles()">
                <mat-icon>cloud_upload</mat-icon> Upload All
              </button>
            </div>
            <cdk-virtual-scroll-viewport class="pending-files-viewport" itemSize="48">
              <div *cdkVirtualFor="let file of newFiles" fxLayout="row" fxLayoutAlign="space-between center"
                   fxLayoutGap="10px" class="pending-file-row">
                <div fxFlex="40" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                  <mat-icon color="accent">description</mat-icon>
                  <div *ngIf="!file.editingName" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span>{{ file.name }}</span>
                    <button mat-icon-button color="accent" (click)="file.enableNameEdit()" matTooltip="Edit File Name" [disabled]="uploading">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                  <div *ngIf="file.editingName !== undefined" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-form-field>
                      <input matInput [(ngModel)]="file.editingName">
                      <span matSuffix>.{{ file.extension }}</span>
                    </mat-form-field>
                    <button mat-icon-button color="accent" (click)="file.saveNameEdit()" matTooltip="Save File Name">
                      <mat-icon>save</mat-icon>
                    </button>
                  </div>
                </div>
                <div fxFlex="15" fxLayoutAlign="center center">
                  <small class="category-badge">{{ getCategoryLabel(file.category) }}</small>
                </div>
                <div fxFlex="10" fxLayoutAlign="center center">
                  <small class="text-info">{{ formatFileSize(file.file.size) }}</small>
                </div>
                <div fxFlex="20" fxLayoutAlign="end center" fxLayoutGap="5px">
                  <div *ngIf="!isValidExtension(file)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon color="warn">error</mat-icon>
                    <small color="warn">Invalid Extension</small>
                  </div>
                  <div *ngIf="file.uploading" class="upload-progress" fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-progress-bar mode="determinate" [value]="file.progress" [class.animate-progress]="file.progress > 0" style="width: 80px;"></mat-progress-bar>
                    <small class="text-info upload-percent">{{ file.progress }}%</small>
                  </div>
                  <button *ngIf="file.uploadFailed" mat-icon-button color="warn" matTooltip="Retry Upload"
                          [disabled]="uploading"
                          (click)="retryUpload(file)">
                    <mat-icon>refresh</mat-icon>
                  </button>
                  <button *ngIf="isValidExtension(file) && !file.uploading && !file.uploadFailed" mat-icon-button color="primary" matTooltip="Upload"
                          [disabled]="!file.fileHash || uploading || file.editingName !== undefined"
                          (click)="uploadFile(file)">
                    <mat-icon>cloud_upload</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" matTooltip="Remove"
                          [disabled]="uploading"
                          (click)="removeNewFile(file)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Filter card -->
      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content>
          <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
            <mat-form-field class="accent">
              <mat-label>Search files by name</mat-label>
              <input matInput type="text"
                [(ngModel)]="searchTerm"
                (ngModelChange)="debounceSearchTermChanged()"
                (keyup.esc)="searchTerm=''; onCategoryChanged()"
                name="searchTerm"
                placeholder="Search files">
              <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; onCategoryChanged()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field class="accent">
              <mat-label>Category</mat-label>
              <mat-select [(value)]="categoryFilter" (selectionChange)="onCategoryChanged()">
                <mat-option [value]="undefined">All Categories</mat-option>
                <mat-option *ngFor="let cat of authorizedCategories" [value]="cat">{{ getCategoryLabel(cat) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="accent">
              <mat-label>Order Files By</mat-label>
              <mat-select [(value)]="orderSelection" (selectionChange)="orderChanged()">
                <mat-option value="0|asc">File Name (A-Z)</mat-option>
                <mat-option value="0|desc">File Name (Z-A)</mat-option>
                <mat-option value="1|asc">File Size (Smallest)</mat-option>
                <mat-option value="1|desc">File Size (Largest)</mat-option>
                <mat-option value="2|asc">Category (A-Z)</mat-option>
                <mat-option value="2|desc">Category (Z-A)</mat-option>
                <mat-option value="3|desc">Uploaded Date (Newest)</mat-option>
                <mat-option value="3|asc">Uploaded Date (Oldest)</mat-option>
                <mat-option value="4|desc">Linked Items (Most)</mat-option>
                <mat-option value="4|asc">Linked Items (Fewest)</mat-option>
              </mat-select>
            </mat-form-field>

            <div fxLayout="row" fxLayoutGap="10px">
              <button
                type="submit"
                mat-flat-button color="primary"
                (click)="loadFiles()"
                matTooltip="Search"
                [class.button-spinner]="loading"
                [disabled]="loading">
                <mat-icon>search</mat-icon> Search
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Bulk actions toolbar -->
      <div *ngIf="dataSource.length > 0" class="bulk-actions-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <button mat-icon-button color="accent" *ngIf="!hasSelectedAll()" (click)="selectAll(true)" matTooltip="Select All">
            <mat-icon>select_all</mat-icon>
          </button>
          <button mat-icon-button color="accent" *ngIf="hasSelectedAll()" (click)="selectAll(false)" matTooltip="Deselect All">
            <mat-icon>deselect</mat-icon>
          </button>
        </div>

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <button mat-icon-button color="primary" (click)="linkSelectedToProducts()" [disabled]="!hasSelected()"
                  matTooltip="Link Selected Files To Products">
            <mat-icon>add_link</mat-icon>
          </button>

          <div>|</div>

          <button mat-icon-button color="primary" (click)="deleteSelected()" [disabled]="!hasSelected()"
                  matTooltip="Delete Selected Files">
            <mat-icon>delete</mat-icon>
          </button>

          <div>|</div>

          <button mat-icon-button color="primary" (click)="downloadSelected()" [disabled]="!hasSelected()" matTooltip="Download Selected Files">
            <mat-icon>file_download</mat-icon>
          </button>

          <button mat-icon-button color="primary" (click)="downloadSelectedZip()" [disabled]="!hasSelected()" matTooltip="Download Selected Files As Zip">
            <mat-icon>folder_zip</mat-icon>
          </button>
        </div>
      </div>

      <!-- File rows -->
      <mat-card class="contrast" *ngFor="let file of dataSource" [ngClass]="{'mat-card-inline-sm': true, 'selection-highlight': file.isSelected}" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
          <div class="file-selector" [ngClass]="{'file-selector-selected': file.isSelected}" fxLayout="column" fxLayoutAlign="start center">
            <mat-icon *ngIf="file.isSelected" (click)="file.isSelected = false">check_box</mat-icon>
            <mat-icon *ngIf="!file.isSelected" (click)="file.isSelected = true">check_box_outline_blank</mat-icon>
          </div>
          <div fxFlex="28" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
            <strong [innerHtml]="file?.fileName | encodeHtml | highlight: searchTerm"></strong>
          </div>
          <div fxFlex="12" fxLayoutAlign="center center">
            <small class="category-badge">{{ getCategoryLabel(file?.category) }}</small>
          </div>
          <div fxFlex="8" fxLayoutAlign="center center">
            <small class="text-info">{{ formatFileSize(file?.fileSize) }}</small>
          </div>
          <div fxFlex="12" fxLayoutAlign="center center">
            <div fxLayoutAlign="center start" fxLayout="column">
              <small [matTooltip]="file?.createdDate"><span class="text-muted">Uploaded</span> {{ timeAgoString(file?.createdDate) }}</small>
              <small *ngIf="hasBeenReplaced(file)" [matTooltip]="file?.updatedDate"><span class="text-muted">Replaced</span> {{ timeAgoString(file?.updatedDate) }}</small>
            </div>
          </div>
          <div fxFlex="13" fxLayoutAlign="center center" fxLayoutGap="5px">
            <small *ngIf="file?.subjectCount != null">{{ file.subjectCount }} {{ pluralize('linked item', file.subjectCount) }}</small>
            <button mat-icon-button color="accent" (click)="linkFileToProducts(file)" matTooltip="Link To Products">
              <mat-icon>add_link</mat-icon>
            </button>
          </div>
          <div fxFlex="10" fxLayoutAlign="end center" fxLayoutGap="5px">
            <button mat-icon-button matTooltip="Download" (click)="downloadFile(file)">
              <mat-icon>download</mat-icon>
            </button>
            <button mat-icon-button color="warn"
                    [matTooltip]="file.subjectCount > 0 ? 'Cannot delete — linked to ' + file.subjectCount + ' ' + pluralize('item', file.subjectCount) : 'Delete'"
                    [disabled]="file.subjectCount > 0"
                    (click)="deleteFile(file)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Empty state -->
      <mat-card class="contrast" *ngIf="!loading && dataSource.length === 0">
        <mat-card-content fxLayoutAlign="center center">
          <small class="text-info">No files found</small>
        </mat-card-content>
      </mat-card>

      <!-- Paginator -->
      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
          [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
